module.exports = __webpack_public_path__ + "static/media/RH_PDF_bg_original.e49c5011.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/RH_PDF_bg_original.png
// module id = 772
// module chunks = 10